export function formatNumeroDeVagas() {
  let min = 1;
  let max = 99999;

  if (this.cargo.quantidadeVagas.toString().replace(".", "") > max)
    this.cargo.quantidadeVagas = max

  if (this.cargo.quantidadeVagas.toString().replace(".", "") < min)
    this.cargo.quantidadeVagas = min

  var rx = /(\d+)(\d{3})/;
  this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(/^\d+/, function (w) {
    while (rx.test(w)) {
      w = w.replace(rx, '$1.$2');
    }
    return w;
  });
}

const selecioneUmaOpcao = { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true }

export function carregarTipoVinculo(tabelasAuxiliares) {
  const tiposVinculo = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoVinculo.map((t) => {
    return {
      value: t.Id,
      text: t.Descricao,
    };
  })]
  return tiposVinculo;
}

export function carregarTipoRegimeJuridico(tabelasAuxiliares) {
  const tiposRegimeJuridico = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoRegimeJuridico.map(
    (t) => {
      return {
        value: t.Id,
        text: t.Descricao,
      };
    }
  )]
  return tiposRegimeJuridico;
}

export function carregarTipoRegimePrevidenciario(tabelasAuxiliares) {
  const tiposRegimePrevidenciario = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoRegimePrevidenciario.map(
    (t) => {
      return {
        value: t.Id,
        text: t.Descricao,
      };
    }
  )]
  return tiposRegimePrevidenciario;
}

export function carregarTipoNatureza(tabelasAuxiliares) {
  const tiposNatureza = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoNatureza.map((t) => {
    return {
      value: t.Id,
      text: t.Descricao,
    };
  })]
  return tiposNatureza;
}

export function carregarTipoEscolaridade(tabelasAuxiliares) {
  const tiposEscolaridade = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoEscolaridade.map(
    (t) => {
      return {
        value: t.Id,
        text: t.Descricao,
      };
    }
  )]
  return tiposEscolaridade;
}

export function carregarTipoSituacao(tabelasAuxiliares) {
  const tiposSituacao = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoSituacao.map((t) => {
    return {
      value: t.Id,
      text: t.Descricao,
    };
  })]
  return tiposSituacao;
}

export function carregarTipoAtoNormativo(tabelasAuxiliares) {
  const tiposAtoNormativo = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoAtoNormativo.map(
    (t) => {
      return {
        value: t.Id,
        text: t.Descricao,
      };
    }
  )]
  return tiposAtoNormativo;
}

export function carregarTipoAlteracaoNormativa(tabelasAuxiliares) {
  const tiposAlteracaoNormativa = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoAlteracaoNormativa.map((t) => {
    return {
      value: t.Id,
      text: t.Descricao,
    };
  }
  )]
  return tiposAlteracaoNormativa;
}

export function carregarTipoVeiculoPublicacaoNormativo(tabelasAuxiliares) {
  const tiposVeiculoPublicacaoNormativo = [selecioneUmaOpcao, ...tabelasAuxiliares.tipoVeiculoPublicacaoNormativo.map((t) => {
    return {
      value: t.Descricao,
      text: t.Descricao,
    };
  }
  )]
  return tiposVeiculoPublicacaoNormativo;
}

export function getValidationState({ dirty, validated, valid = null }) {
  return dirty || validated ? valid : null;
}